export const getStatus = (status: string, property: 'text' | 'bg') => {
   switch (status) {
      case 'Submitted':
         return property === 'text' ? 'text-blue' : 'bg-blue';
      case 'Draft':
         return property === 'text' ? 'text-grey-200' : 'bg-grey-200';
      case 'Rejected':
         return property === 'text' ? 'text-dark-red' : 'bg-dark-red';
      case 'Under Review':
         return property === 'text' ? 'text-light-orange' : 'bg-light-orange';
      case 'Requires Update':
         return property === 'text' ? 'text-dark-orange' : 'bg-dark-orange';
      case 'Approved':
         return property === 'text' ? 'text-dark-green' : 'bg-dark-green';
      case 'Issued':
         return property === 'text' ? 'text-dark-green' : 'bg-dark-green';
      default:
         return ``;
   }
};
